import { render } from "./premium.vue?vue&type=template&id=5c2728cf&scoped=true"
import script from "./premium.vue?vue&type=script&lang=js"
export * from "./premium.vue?vue&type=script&lang=js"

import "./premium.vue?vue&type=style&index=0&id=5c2728cf&scoped=true&lang=css"
import "./premium.vue?vue&type=style&index=1&id=5c2728cf&lang=css"
script.render = render
script.__scopeId = "data-v-5c2728cf"

export default script